import "core-js/modules/es.number.constructor.js";
export var BASE_COMMENTS_KEY = 'userCommentSubscriptions';
var userCommentSubscriptionKeys = {
  subscriptions: [BASE_COMMENTS_KEY],
  contentSubscriptions: function contentSubscriptions(contentId) {
    return [BASE_COMMENTS_KEY, Number(contentId)];
  }
};
export default userCommentSubscriptionKeys;